import { render, staticRenderFns } from "./PCEdetail.vue?vue&type=template&id=6f1249f3&scoped=true"
import script from "./PCEdetail.vue?vue&type=script&lang=js"
export * from "./PCEdetail.vue?vue&type=script&lang=js"
import style0 from "./PCEdetail.vue?vue&type=style&index=0&id=6f1249f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1249f3",
  null
  
)

export default component.exports